import React from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';
import compose from '../../hoc/compose';
var applyTextLabelDefaultProps = function applyTextLabelDefaultProps(child) {
  return _.invoke(child, 'type.getDisplayName') === 'TextLabel' ? /*#__PURE__*/React.cloneElement(child, {
    ellipsisProps: _.assign({
      marginTop: -6
    }, child.props.ellipsisProps)
  }) : child;
};
var sectionDivider = function sectionDivider(_ref) {
  var automationId = _ref.automationId,
    dataHook = _ref.dataHook,
    getClassName = _ref.getClassName,
    disabled = _ref.disabled,
    children = _ref.children;
  return /*#__PURE__*/React.createElement("div", {
    "data-aid": automationId,
    "data-hook": dataHook,
    disabled: disabled,
    className: getClassName('control-section-divider') + (disabled ? ' disabled' : '')
  }, /*#__PURE__*/React.createElement("div", {
    className: "section-divider-content"
  }, React.Children.map(children, applyTextLabelDefaultProps)));
};
sectionDivider.displayName = 'SectionDivider';
sectionDivider.propTypes = {
  /** Set a disabled behaviour on the component */
  disabled: PropTypes.bool,
  /** Any element to be displayed inside */
  children: PropTypes.node
};
sectionDivider.defaultProps = {
  disabled: false
};
export default compose(sectionDivider);